
import { Link } from "react-router-dom";

type NavItem = {
  name: string;
  path: string;
};

type MarketingNavProps = {
  items: NavItem[];
};

const MarketingNav = ({ items }: MarketingNavProps) => {
  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId.substring(1));
    
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="flex items-center justify-center space-x-6">
      <a
        href="#how-it-works"
        className="font-medium text-gray-300 hover:text-purple-400 transition-colors"
        onClick={(e) => handleSmoothScroll(e, "#how-it-works")}
      >
        How It Works
      </a>
      <a
        href="#dashboard-feature"
        className="font-medium text-gray-300 hover:text-purple-400 transition-colors"
        onClick={(e) => handleSmoothScroll(e, "#dashboard-feature")}
      >
        Features
      </a>
      <a
        href="#pricing"
        className="font-medium text-gray-300 hover:text-purple-400 transition-colors"
        onClick={(e) => handleSmoothScroll(e, "#pricing")}
      >
        Pricing
      </a>
      <a
        href="#faq"
        className="font-medium text-gray-300 hover:text-purple-400 transition-colors"
        onClick={(e) => handleSmoothScroll(e, "#faq")}
      >
        FAQ
      </a>
      <a
        href="#rewards"
        className="font-medium text-gray-300 hover:text-purple-400 transition-colors"
        onClick={(e) => handleSmoothScroll(e, "#rewards")}
      >
        Rewards
      </a>
    </div>
  );
};

export default MarketingNav;
